// src/components/FoundingCollectorBadge/FoundingCollectorBadge.jsx
//
// Cosmetic "Founding Collector" status marker. Admin-granted only; it has no
// effect on coins, tiers, quizzes, cooldowns or collections.
import React from 'react';
import styles from './FoundingCollectorBadge.module.css';

export const FOUNDING_COLLECTOR_GOLD = '#C8912F';
export const FOUNDING_COLLECTOR_TOOLTIP = 'Founding Collector — one of Aluvo’s earliest members.';

/** Small gold star icon. Renders nothing unless `isFoundingCollector` is truthy. */
export function FoundingCollectorIcon({ isFoundingCollector = true, size = 'sm', className = '' }) {
    if (!isFoundingCollector) return null;
    return (
        <span
            className={`${styles.icon} ${styles[size] ?? ''} ${className}`}
            title={FOUNDING_COLLECTOR_TOOLTIP}
            aria-label={FOUNDING_COLLECTOR_TOOLTIP}
            role="img"
            data-testid="founding-collector-icon"
        >
            {/* Filled five-point star — matches the Ionicons "star" glyph used on mobile */}
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path
                    fill={FOUNDING_COLLECTOR_GOLD}
                    d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
                />
            </svg>
        </span>
    );
}

/** Gold "Founding Collector" text label, for use beneath the username on profile headers. */
export function FoundingCollectorLabel({ isFoundingCollector = true, className = '' }) {
    if (!isFoundingCollector) return null;
    return (
        <p
            className={`${styles.label} ${className}`}
            title={FOUNDING_COLLECTOR_TOOLTIP}
            data-testid="founding-collector-label"
        >
            <FoundingCollectorIcon size="xs" />
            Founding Collector
        </p>
    );
}

export default FoundingCollectorIcon;
